import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, ViewChild, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { NoteModel } from 'app/shared/components/note/note.model';
import { FocusService } from '../../focus.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { NoteComponent } from '../../../../shared/components/note/note.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-abstract-action-confirmation-dialog',
  styleUrls: ['./abstract-action-confirmation-dialog.component.scss'],
  templateUrl: './abstract-action-confirmation-dialog.component.html',
  imports: [FormsModule, ReactiveFormsModule, CdkScrollable, MatDialogContent, NoteComponent, MatDialogActions, MatButton],
})
export class AbstractActionConfirmationDialogComponent implements OnChanges {
  @Output() public acceptEvent = new EventEmitter<void>();
  @Input() public acceptLabel: string;
  @Input() public cdkFocusInitialOnButtonFlag = true;
  @Input() public cdkFocusInitialOnCancelButtonFlag = true;
  @Output() public closeEvent = new EventEmitter<void>();
  @Output() public declineEvent = new EventEmitter<void>();
  @Input() public declineLabel: string;
  @Input() public formGroup: FormGroup;
  @Input() public formInvalidFlag: boolean;
  @Input() public messageLine1: string;
  @Input() public messageLine2: string | null;
  @Input() public note: NoteModel | null;
  @Input() public subMessageLine1: string | null;
  @Input() public subMessageLine2: string | null;

  @ViewChild('_acceptButton') private _acceptButton: MatButton;
  @ViewChild('_declineButton') private _declineButton: MatButton;

  private _focusService = inject(FocusService);

  public linkClickedEventHandler(): void {
    this.closeEvent.emit();
  }

  public ngOnChanges(): void {
    this.setFocus();
  }

  public onAcceptClickedHandler(): void {
    this.acceptEvent.emit();
  }

  public onDeclineClickedHandler(): void {
    this.declineEvent.emit();
  }

  public setFocus(): void {
    if (this.cdkFocusInitialOnButtonFlag) {
      this._focusService.setTimeoutOutsideAngular(() => {
        if (this.cdkFocusInitialOnCancelButtonFlag) {
          this._declineButton?.focus();
        } else {
          this._acceptButton?.focus();
        }
      });
    }
  }
}
